import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { Copy } from 'lucide-react';
import { toast } from 'sonner';

const Code = ({ inline, className, children, ...props }) => {
  const text = String(children).replace(/\n$/, '');
  if (inline || !className && !text.includes('\n')) {
    return <code className="px-1.5 py-0.5 rounded bg-foreground/10 font-mono text-[0.85em]" {...props}>{children}</code>;
  }
  const lang = /language-(\w+)/.exec(className || '')?.[1];
  return (
    <div className="my-3 rounded-xl overflow-hidden border border-border bg-[hsl(var(--foreground)/0.04)]">
      <div className="flex items-center justify-between px-3 py-1.5 text-[11px] text-muted-foreground border-b border-border">
        <span className="font-mono">{lang || 'code'}</span>
        <button onClick={() => { navigator.clipboard.writeText(text); toast.success('Copié'); }} className="flex items-center gap-1 hover:text-foreground"><Copy className="h-3 w-3" /> Copier</button>
      </div>
      <pre className="p-3 overflow-x-auto text-xs leading-relaxed font-mono"><code>{text}</code></pre>
    </div>
  );
};

export const Markdown = ({ children }) => (
  <div className="md-body">
    <ReactMarkdown
      remarkPlugins={[remarkGfm]}
      components={{
        code: Code,
        pre: ({ children }) => <>{children}</>,
        a: ({ children, href }) => <a href={href} target="_blank" rel="noreferrer" className="text-primary underline underline-offset-2">{children}</a>,
        table: ({ children }) => <div className="my-3 overflow-x-auto"><table className="text-xs border-collapse w-full">{children}</table></div>,
        th: ({ children }) => <th className="border border-border px-2 py-1.5 text-left font-semibold bg-foreground/5">{children}</th>,
        td: ({ children }) => <td className="border border-border px-2 py-1.5 align-top">{children}</td>,
      }}
    >
      {children}
    </ReactMarkdown>
  </div>
);
